import React from 'react';
import MUIBreadcrumbs from '@mui/material/Breadcrumbs';
import useBreadcrumbs from '@/hooks/useBreadcrumbs';

function Breadcrumbs() {
  const crumbs = useBreadcrumbs();
  const noCrumb = crumbs.length <= 1;

  return noCrumb ? null : (
    <MUIBreadcrumbs aria-label="breadcrumbs navigation">
      {crumbs.map((crumb) => crumb)}
    </MUIBreadcrumbs>
  );
}

export default Breadcrumbs;
